import React, { PureComponent } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";
import { Popup, Icon } from "semantic-ui-react";

import { selectCopy } from "../../state/reducers/locale/copySelector.js";
import { MODIFIED_AT_TIME_FORMAT } from "../config.js";

class ResourceSunsetMarker extends PureComponent {
  static propTypes = {
    data: PropTypes.object.isRequired,
    copyKey: PropTypes.string.isRequired,
    copy: PropTypes.func.isRequired
  };

  static defaultProps = {
    copyKey: "image"
  };

  getSunsetMarkerProps = () => {
    const {
      data: { sunset },
      copyKey,
      copy
    } = this.props;

    const isBefore = moment().isSameOrBefore(sunset.date);

    const label = `${copy(`${copyKey}.sunset.title_label`)} ${moment(
      sunset.date
    ).format(MODIFIED_AT_TIME_FORMAT)}`;

    return {
      icon: "bed",
      color: isBefore ? "orange" : "red",
      label
    };
  };

  render() {
    const { data } = this.props;

    if (!data.sunset) return null;

    const iconData = this.getSunsetMarkerProps();

    return (
      <Popup
        trigger={
          <Icon
            className={`${iconData.icon}`}
            color={iconData.color}
            size="large"
          />
        }
        position="top right"
        size="tiny"
        offset={[5, 0]}
        hideOnScroll
        content={iconData.label}
      />
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(ResourceSunsetMarker);
